// extracted by mini-css-extract-plugin
module.exports = {"company":"_1ApwMw5uOk2JrTwv-JBa_s","paragraph":"_3k9XuYHCYVKNCZ7ZcI-pRl","comapniesLogos":"_3pCEuWCXnpr6h5jndqX_RY","logo":"YR5XDwkgrhpC1RV6hp_FN","row":"_3I6NCM8hcRVF4zBpgX6VoF"};